
export const uploadImage = async (file) => {
  try {
    if (!file || !(file instanceof File) || !file.type.startsWith('image/')) {
      throw new Error('Invalid file type. Please upload an image (e.g., PNG, JPEG).');
    }

    const IMGBB_API_KEY = 'f0aba3d7d8ab0461e399ba9e29f6723d';
    const UPLOAD_API_ENDPOINT = `https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`;

    const formData = new FormData();
    formData.append('image', file);

    const response = await fetch(UPLOAD_API_ENDPOINT, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
      throw new Error(`Image upload failed: ${response.status} - ${errorData.message || 'Server error'}`);
    }

    const result = await response.json();
    const uploadedImageUrl = result.data.url;

    if (!uploadedImageUrl) {
      throw new Error('Upload successful but no image URL returned by ImgBB API.');
    }

    console.log('Image uploaded successfully to ImgBB:', uploadedImageUrl);

    return uploadedImageUrl;
  } catch (error) {
    console.error('Error uploading image to ImgBB:', error);
    throw new Error(`Failed to upload image: ${error.message}`);
  }
};

export const revokeImageUrl = (url) => {
  if (url && typeof url === 'string' && url.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
};